<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="n_content_ti"><span>关于我们</span> </div>
			<div class="de_content_box">
				<div class="about-content">
					<div class="about-banner">
						<div class="banner-text">
							<h1>-</h1>
							<p>专业的游戏账号租赁平台</p>
						</div>
					</div>
					
					<div class="about-section">
						<div class="section-title">
							<i class="el-icon-office-building"></i>
							<span>平台简介</span>
						</div>
						<div class="section-content">
							<p>是国内专业的游戏账号租赁服务平台，致力于为广大游戏玩家提供安全、便捷、实惠的账号租赁服务。我们秉持"诚信为本、用户至上"的经营理念，通过严格的风控体系和优质的客服服务，为玩家打造安心的交易环境。</p>
							<p>平台涵盖和平精英、王者荣耀、穿越火线等多款热门游戏的账号租赁，满足不同玩家的多样化需求。</p>
						</div>
					</div>

					<div class="about-section">
						<div class="section-title">
							<i class="el-icon-star-on"></i>
							<span>我们的优势</span>
						</div>
						<div class="section-content">
							<div class="advantage-list">
								<div class="advantage-item">
									<div class="adv-icon">
										<i class="el-icon-lock"></i>
									</div>
									<div class="adv-info">
										<h4>安全交易</h4>
										<p>平台担保交易，租金托管，账号安全有保障</p>
									</div>
								</div>
								<div class="advantage-item">
									<div class="adv-icon">
										<i class="el-icon-service"></i>
									</div>
									<div class="adv-info">
										<h4>贴心客服</h4>
										<p>24小时在线客服，快速响应解决问题</p>
									</div>
								</div>
								<div class="advantage-item">
									<div class="adv-icon">
										<i class="el-icon-circle-check"></i>
									</div>
									<div class="adv-info">
										<h4>品质保证</h4>
										<p>严格审核账号质量，确保良好游戏体验</p>
									</div>
								</div>
								<div class="advantage-item">
									<div class="adv-icon">
										<i class="el-icon-refresh"></i>
									</div>
									<div class="adv-info">
										<h4>灵活租赁</h4>
										<p>多种租期可选，按需选择随时退租</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="about-section">
						<div class="section-title">
							<i class="el-icon-phone"></i>
							<span>联系我们</span>
						</div>
						<div class="section-content">
							<div class="contact-list">
								<div class="contact-item">
									<i class="el-icon-service"></i>
									<span class="label">在线客服：</span>
									<span class="value">点击页面右下角客服图标</span>
								</div>
								<div class="contact-item">
									<i class="el-icon-message"></i>
									<span class="label">工作时间：</span>
									<span class="value">周一至周日 0:00-23:59</span>
								</div>
								<div class="contact-item">
									<i class="el-icon-warning"></i>
									<span class="label">投诉建议：</span>
									<span class="value">请联系在线客服或添加客服微信</span>
								</div>
							</div>
						</div>
					</div>

					<!-- <div class="about-section">
						<div class="section-title">
							<i class="el-icon-document"></i>
							<span>服务协议</span>
						</div>
						<div class="section-content">
							<div class="agreement-list">
								<div class="agreement-item" @click="showAgreement(1)">
									<span>《用户服务协议》</span>
									<i class="el-icon-arrow-right"></i>
								</div>
								<div class="agreement-item" @click="showAgreement(2)">
									<span>《隐私政策》</span>
									<i class="el-icon-arrow-right"></i>
								</div>
								<div class="agreement-item" @click="showAgreement(3)">
									<span>《账号租赁规则》</span>
									<i class="el-icon-arrow-right"></i>
								</div>
								<div class="agreement-item" @click="showAgreement(4)">
									<span>《支付协议》</span>
									<i class="el-icon-arrow-right"></i>
								</div>
							</div>
						</div>
					</div> -->

					<div class="about-section">
						<div class="section-title">
							<i class="el-icon-info"></i>
							<span>版权声明</span>
						</div>
						<div class="section-content">
							<p>及相关图形、文字等版权均为本平台所有，未经书面授权，任何单位及个人不得以任何方式非法使用。</p>
							<p>平台上的游戏账号信息由商家自行发布，平台仅提供交易撮合服务，不对账号内容承担任何责任。</p>
							<p class="copyright">© 2026 - All rights reserved.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
export default {
	data() {
		return {
			
		}
	},
	created: function () {
		
	},
	methods: {
		showAgreement(type) {
			const titles = {
				1: '用户服务协议',
				2: '隐私政策',
				3: '账号租赁规则',
				4: '支付协议'
			};
			this.$alert('<p>该协议内容正在完善中，如有问题请联系客服。</p>', titles[type], {
				confirmButtonText: '知道了',
				dangerouslyUseHTMLString: true
			});
		}
	}
}
</script>

<style scoped>
.about-content {
	padding: 0;
}
.about-banner {
	background: linear-gradient(135deg, #1f9535 0%, #2eb872 100%);
	padding: 60px 30px;
	text-align: center;
	color: #fff;
	margin-bottom: 30px;
}
.banner-text h1 {
	font-size: 36px;
	margin-bottom: 10px;
}
.banner-text p {
	font-size: 18px;
	opacity: 0.9;
}
.about-section {
	margin-bottom: 35px;
}
.section-title {
	display: flex;
	align-items: center;
	font-size: 18px;
	font-weight: bold;
	color: #333;
	margin-bottom: 15px;
	padding-bottom: 10px;
	border-bottom: 1px solid #eee;
}
.section-title i {
	font-size: 20px;
	color: #1f9535;
	margin-right: 8px;
}
.section-content {
	padding: 0 5px;
}
.section-content p {
	line-height: 1.8;
	color: #606266;
	font-size: 14px;
	margin-bottom: 12px;
}
.section-content p:last-child {
	margin-bottom: 0;
}
.advantage-list {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px;
}
.advantage-item {
	display: flex;
	align-items: flex-start;
	padding: 15px;
	background: #f5f7fa;
	border-radius: 8px;
}
.adv-icon {
	width: 50px;
	height: 50px;
	background: linear-gradient(135deg, #1f9535 0%, #2eb872 100%);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 15px;
	flex-shrink: 0;
}
.adv-icon i {
	font-size: 24px;
	color: #fff;
}
.adv-info h4 {
	font-size: 15px;
	color: #303133;
	margin-bottom: 5px;
}
.adv-info p {
	font-size: 13px;
	color: #909399;
	margin: 0;
	line-height: 1.5;
}
.contact-list {
	background: #f5f7fa;
	padding: 20px;
	border-radius: 8px;
}
.contact-item {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
}
.contact-item:last-child {
	margin-bottom: 0;
}
.contact-item i {
	font-size: 18px;
	color: #1f9535;
	margin-right: 10px;
}
.contact-item .label {
	font-weight: bold;
	color: #303133;
	margin-right: 5px;
}
.contact-item .value {
	color: #606266;
}
.agreement-list {
	background: #f5f7fa;
	border-radius: 8px;
	overflow: hidden;
}
.agreement-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	border-bottom: 1px solid #eee;
	cursor: pointer;
	transition: all 0.3s;
}
.agreement-item:last-child {
	border-bottom: none;
}
.agreement-item:hover {
	background: #e8f5e9;
}
.agreement-item span {
	color: #303133;
	font-size: 14px;
}
.agreement-item i {
	color: #909399;
}
.copyright {
	text-align: center;
	color: #909399 !important;
	font-size: 13px !important;
	margin-top: 20px !important;
}
@media (max-width: 768px) {
	.about-banner {
		padding: 40px 20px;
	}
	.banner-text h1 {
		font-size: 28px;
	}
	.banner-text p {
		font-size: 15px;
	}
	.advantage-list {
		grid-template-columns: 1fr;
	}
	.advantage-item {
		padding: 12px;
	}
	.section-title {
		font-size: 16px;
	}
}
</style>
